export const getTelegramBotUrl = () =>
  process.env.REACT_APP_TELEGRAM_BOT_URL ?? 'https://t.me/PrivateGateVPNbot';
